import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=561d8ba6&"
import script from "./AdminForm.vue?vue&type=script&lang=js&"
export * from "./AdminForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports